import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';

import { onClickCreateNewCategory } from 'actions/library/item';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import DropdownCreateable from '../DropdownCreateable';
import styles from './GeneralInformation.css';

class GeneralInformation extends Component {
  render() {
    const {
      categories,
      onClickCreateNewCategory,
      uploadImagePlaceholder,
      itemDetail,
      isDisableForm,
    } = this.props;

    return (
      <div className="form-group">
        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Image for POS </span>
        </div>
        <div
          className={`col-lg-9 col-md-8 col-sm-3 ${
            styles['image-for-pos-wrapper']
          }`}
        >
          <Field
            name="image.url"
            component={UploadImage}
            placeholder={uploadImagePlaceholder}
            className={styles['img-ecommerce']}
            backgroundColor={itemDetail ? itemDetail.background_color : null}
            disableEditAndDeleteButton={isDisableForm}
            disableEditDeleteButtonFeature={isDisableForm}
          />
        </div>
        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Product Name </span>
        </div>
        <div className="col-lg-9 col-md-8">
          <div className="form-group">
            <Field
              component={SettingField}
              className="form-control"
              name="name"
              maxLength="40"
              placeholder="Write product name..."
              type="text"
            />
          </div>
        </div>

        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Category </span>
        </div>
        <div className="col-lg-9 col-md-8">
          <div className={`form-group ${styles.categories}`}>
            <Field
              component={DropdownCreateable}
              name="category_id"
              options={this.formatCategories(categories)}
              onCreate={onClickCreateNewCategory}
              list={categories}
              placeholder="Select an option"
            />
          </div>
        </div>

        <div className={`${styles['field-wrapper']} col-lg-3 col-md-4`}>
          <span className={styles['field-name']}> Description </span>
          <div className={styles['toggle-badge-recommend']}>
            Mandatory For Online Store
          </div>
        </div>
        <div className="col-lg-9 col-md-8">
          <div className="form-group">
            <Field
              component="textarea"
              className="form-control"
              placeholder="Item Description..."
              maxLength={2000}
              name="description"
              type="text"
              rows="5"
            />
          </div>
        </div>
      </div>
    );
  }

  formatCategories = categories => {
    const formatCategory = [];
    categories.map(function(category) {
      if (category.id > 0) {
        formatCategory.push({ value: category.id, label: category.name });
      }
    });
    return formatCategory;
  };
}

const mapDispatchToProps = {
  onClickCreateNewCategory,
};

export default connect(
  null,
  mapDispatchToProps
)(GeneralInformation);
